import { shape, string, number, bool } from 'prop-types';

/** Possible metadata keys. */
export const metadataProps = {
  /** ISRC, UPC or EAN of entity */
  entityId: string,
  /** Release date of entity */
  releaseDate: number,
  /** Primary artist of entity */
  primaryArtist: string,
  /** Number of tracks within this group */
  groupChildCount: number,
  /** Number of tracks related to the entity */
  trackCount: number,
  /** Number of releases related to the entity  */
  releaseCount: number,
  /** Number of artists related to the entity */
  artistCount: number,
  /** Metadata entity with different keys based on entity type */
  metaData: shape({
    /** All time performance of entity */
    performance_rtd: number,
  }),
  /** Enabling this will show more information in the metadata */
  showDetailedMetadata: bool,
};
